import React from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = ({
  company,
  navItems,
  isScrolled,
  mobileMenuOpen,
  setMobileMenuOpen,
  activeSection,
  onNavigate,
  onConsult,
}) => {
  return (
    <>
      <nav
        className={`fixed top-0 w-full z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md py-4' : 'bg-transparent py-6'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center">
          <div className="cursor-pointer" onClick={() => onNavigate('Home')}>
            <div className="flex items-center gap-3">
              <img
                src={company.logo}
                alt={`${company.name} logo`}
                className={`h-11 w-11 rounded-full object-cover border transition-all duration-300 ${
                  isScrolled ? 'border-amber-200/70 shadow-sm' : 'border-white/30 shadow-none'
                }`}
              />
              <div>
                <p className={`text-2xl font-medium tracking-widest transition-colors duration-300 ${isScrolled ? 'text-black' : 'text-white'}`}>
                  {company.name}
                </p>
                <p
                  className={`text-[10px] tracking-[0.2em] uppercase transition-colors duration-300 ${
                    isScrolled ? 'text-stone-500' : 'text-stone-200'
                  }`}
                >
                  {company.subtitle}
                </p>
              </div>
            </div>
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => {
              const isActive = activeSection === item;
              return (
                <button
                  key={item}
                  onClick={() => onNavigate(item)}
                  className={`relative text-sm tracking-wide transition-colors duration-300 ${
                    isActive
                      ? 'text-amber-600 font-medium'
                      : isScrolled
                        ? 'text-stone-600 hover:text-amber-600'
                        : 'text-white hover:text-amber-200'
                  }`}
                >
                  {item}
                  <span
                    className={`absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 bg-amber-600 rounded-full transition-all duration-300 ${
                      isActive ? 'scale-100 opacity-100' : 'scale-0 opacity-0'
                    }`}
                  />
                </button>
              );
            })}
            <button
              onClick={() => onNavigate('Contact')}
              className={`px-6 py-2.5 text-sm tracking-wider uppercase border transition-all duration-300 ${
                isScrolled
                  ? 'border-stone-900 text-stone-900 hover:bg-stone-900 hover:text-white'
                  : 'border-white text-white hover:bg-white hover:text-stone-900'
              }`}
            >
              Get Consultation
            </button>
          </div>

          <button className="lg:hidden text-current" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            {mobileMenuOpen ? (
              <X className={isScrolled ? 'text-black' : 'text-white'} />
            ) : (
              <Menu className={isScrolled ? 'text-black' : 'text-white'} />
            )}
          </button>
        </div>
      </nav>

      <div
        className={`fixed inset-0 z-40 bg-gradient-to-b from-stone-950/70 via-stone-900/60 to-stone-950/70 backdrop-blur-xl transition-transform duration-500 lg:hidden flex flex-col justify-center items-center ${
          mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="w-[88%] max-w-sm rounded-3xl border border-white/10 bg-black/20 px-6 py-8 shadow-2xl">
          <div className="flex flex-col space-y-7 text-center">
          {navItems.map((item) => {
            const isActive = activeSection === item;
            return (
              <button
                key={item}
                onClick={() => onNavigate(item)}
                className={`text-2xl font-light tracking-widest transition-all duration-300 ${
                  isActive
                    ? 'text-amber-500 scale-105'
                    : 'text-stone-200/90 hover:text-white hover:scale-105'
                }`}
              >
                {item}
              </button>
            );
          })}
          <button
            onClick={onConsult}
            className="mt-6 w-full px-8 py-4 bg-amber-700 text-white tracking-widest uppercase text-sm rounded-sm hover:bg-amber-600 transition-colors"
          >
            Get Consultation
          </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
